export const REGULAR = 'regular';
export const ADDITIONAL_SEAT = 'additional_seat';
export const FAMILY = 'family';
